import { v4 as uuid } from 'uuid';

import {
    apiGetPublisherButton,
    apiSetPublisherButton,
} from './api';

export async function getPublisherButton (type = 'button') {
    this.env.errorStore.action = 'getPublisherButton';
    const publisher = this.env.userStore.publisher;

    const res = await apiGetPublisherButton({
        type,
        token: publisher.token,
        traceId: this.env.traceId,
    });

    if (res.data && res.data.data && res.data.data.getWidgets) {
        const edges = res.data.data.getWidgets.edges;
        if (edges && edges.length > 0) {
            this.publisherButton = edges[0].node;
            this.observed.publisherButton = uuid();
        }
    }
}

export async function setPublisherButton ({ buttonWidgetId, publicButton }) {
    this.env.errorStore.action = 'setPublisherButton';
    const publisher = this.env.userStore.publisher;

    const res = await apiSetPublisherButton({
        buttonWidgetId,
        publicButton,
        token: publisher.token,
        traceId: this.env.traceId,
    });

    if (res.data && res.data.data && res.data.data.setPublisherButton) {
        const edges = res.data.data.setPublisherButton.edges;
        if (edges && edges.length > 0) {
            this.publisherButton = edges[0].node;
            this.observed.publisherButton = uuid();
        }
    }
}
